import { JOB_TYPES, STATUSES } from "@/lib/constants";
import { Tooltip, TooltipContent, TooltipTrigger } from "ui/components/tooltip";
import JobNameCell from "@/components/cells/jobs/name-cell";
import { Avatar } from "ui/components/avatar";
import { Badge } from "ui/components/badge";
import { Icon } from "components";
import JobFilters from "@/modules/work/jobs/filters";
import JobTypeSelectionSheet from "@/modules/work/jobs/components/type-selection-sheet";
import { List } from "components";
import ProjectLayout from "@/modules/work/projects/layout";
import React from "react";
import { RenderAvatar } from "components/render-avatar";
import { formatDateForDisplay } from "@/lib/utils";
import { useParams } from "react-router-dom";
import { TypeCell } from "@/modules/work/billables/cells";
import { EmployeeCell } from "components/cell/employee/cell";
import { useProject } from "../context";
import { getEmployeeFields } from "components/user/config";

export default function ProjectJobs() {
  const { project_slug } = useParams();
  const { id } = useProject();

  if (!id) return null

  const fields = [
    "id",
    "name",
    "status",
    "type",
    getEmployeeFields("coordinator"),
    "margin_achievement_percentage",
    "start_date",
    "end_date",
    "flag",
  ];
  const columns = [
    {
      id: "name",
      header: "Name",
      accessorKey: "name",
      sortable: true,
      cell: JobNameCell,
    },
    {
      id: "type",
      header: "Type",
      accessorKey: "type",
      cell: TypeCell,
      sortable: false,
    },
    {
      id:"margin_achievement_percentage",
      header:"Health",
      accessorKey:"margin_achievement_percentage",
    },
    {
      id: "status",
      header: "Status",
      accessorKey: "status",
      cell: ({ getValue }) => {
        return (
          <Badge className={STATUSES[getValue()].className}>
            {STATUSES[getValue()].label}
          </Badge>
        );
      },
    },
    {
      id: "coordinator",
      header: "JC",
      accessorKey: "coordinator",
      cell: EmployeeCell,
    },
    {
      id: "start_date",
      header: "Start Date",
      accessorKey: "start_date",
      sortable: true,
      cell: (info) =>
        formatDateForDisplay(info.getValue(), { addSuffix: true }),
    },
    {
      id: "end_date",
      header: "End Date",
      accessorKey: "end_date",
      sortable: true,
      cell: (info) =>
        formatDateForDisplay(info.getValue(), { addSuffix: true }),
    },
  ];

  const defaultFilters = {
    project: {

      _eq: id,

    },
    status: {
      _neq: "archived",
    },
  };

  return (
    <>
      <List
        title="Jobs"
        storageKey={project_slug}
        endPoint="jobs"
        filters={defaultFilters}
        columns={columns}
        meta={{ fields }}
        sortBy="start_date"
        href={(item) => `/work/jobs/${item.id}`}
        renderFilters={JobFilters}
        custom={true}
      />
      <JobTypeSelectionSheet />
    </>
  );
}
